function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Input } from 'antd';
import omit from 'omit.js';
import { ShowOutlined, HideOutlined } from 'iglooicon';
import classNames from 'classnames';
import formMethods from "../utils/form-methods";
import "./style/index";
import { jsx as _jsx } from "react/jsx-runtime";
var Password = Input.Password;
var IglooPassword = function IglooPassword(props) {
  return /*#__PURE__*/_jsx(Password, _objectSpread(_objectSpread({}, omit(props, formMethods)), {}, {
    className: classNames('igloo-input', props.className),
    iconRender: function iconRender(visible) {
      return visible ? /*#__PURE__*/_jsx(ShowOutlined, {
        style: {
          fontSize: 22,
          color: '#666666'
        }
      }) : /*#__PURE__*/_jsx("span", {
        onClickCapture: function onClickCapture(e) {
          if (!props.value) {
            e.stopPropagation();
          }
        },
        children: /*#__PURE__*/_jsx(HideOutlined, {
          style: {
            fontSize: 22,
            color: props.value ? '#666666' : '#bdbdbd',
            cursor: props.value ? 'pointer' : 'not-allowed'
          }
        })
      });
    }
  }));
};
IglooPassword.formItemPropsHandler = function (config) {
  return {};
};
export default IglooPassword;